import React, { useContext } from "react";
import { AuthContext } from "context/AuthContext";
import TopNav from "ui/dashboard/topnav";
import Limits from "./components/limits";
import UsageChart from "./components/usageCharts";

export default function Usage() {
  const { user } = useContext(AuthContext);
  const classes = React.useMemo(
    () => [
      { label: "Class A", value: "A", color: "rgba(50, 173, 230, 1)" },
      { label: "Class B", value: "B", color: "rgba(52, 199, 89, 1)" },
      { label: "Class C", value: "C", color: "rgba(0, 199, 190, 1)" },
    ],
    [],
  );
  return (
    <div
      className="profile-page flex flex-col items-center h-full mr-6 mb-6"
      style={{ height: "calc(100% - 24px)" }}
    >
      <TopNav title="Usage" />
      <div className="flex  w-full  overflow-y-auto bg-white rounded-3xl pb-6  flex-grow">
        {/* <Limits classes={classes} orgId={user?.orgId} /> */}
        <UsageChart classes={classes} />
      </div>
    </div>
  );
}
